import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Check, Loader, MailX } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Unsubscribe = () => {
  const { lang } = useLanguage();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [resubStatus, setResubStatus] = useState('idle'); // idle | loading | success

  useEffect(() => {
    const run = async () => {
      if (!token) {
        setStatus('error');
        return;
      }
      try {
        const res = await fetch(`${API_URL}/api/marketing/unsubscribe?token=${encodeURIComponent(token)}`);
        setStatus(res.ok ? 'success' : 'error');
      } catch (err) {
        console.error('Unsubscribe failed:', err);
        setStatus('error');
      }
    };
    run();
  }, [token]);

  const handleResubscribe = async () => {
    if (!token || resubStatus === 'loading') return;
    setResubStatus('loading');
    try {
      const res = await fetch(`${API_URL}/api/marketing/resubscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });
      setResubStatus(res.ok ? 'success' : 'idle');
    } catch (err) {
      console.error('Resubscribe failed:', err);
      setResubStatus('idle');
    }
  };

  return (
    <div className="container section-padding" data-testid="unsubscribe-page">
      <div style={{ maxWidth: 480, margin: '0 auto', textAlign: 'center' }}>
        {status === 'loading' && (
          <div data-testid="unsubscribe-loading">
            <Loader size={28} className="spinning" />
          </div>
        )}

        {status === 'success' && (
          <div data-testid="unsubscribe-success">
            <div style={{
              width: 64, height: 64, borderRadius: '50%', background: 'var(--bg-secondary)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px',
            }}>
              <MailX size={28} style={{ color: 'var(--text-secondary)' }} />
            </div>
            <h1 className="heading-2 mb-3">{lang === 'bg' ? 'Отписахте се.' : "You've been unsubscribed."}</h1>
            <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
              {lang === 'bg'
                ? 'Няма да получавате повече маркетингови имейли от KOSTIN.'
                : 'You will no longer receive marketing emails from KOSTIN.'}
            </p>

            {resubStatus === 'success' ? (
              <p className="body-regular mt-5" style={{ color: 'var(--accent-gold)' }} data-testid="resubscribe-success">
                <Check size={16} style={{ display: 'inline', marginRight: 6, verticalAlign: 'middle' }} />
                {lang === 'bg' ? 'Абонирахте се отново успешно.' : "You've been resubscribed."}
              </p>
            ) : (
              <button
                className="btn-secondary mt-5"
                onClick={handleResubscribe}
                disabled={resubStatus === 'loading'}
                data-testid="resubscribe-btn"
              >
                {resubStatus === 'loading'
                  ? (lang === 'bg' ? 'Изчакайте...' : 'Please wait...')
                  : (lang === 'bg' ? 'Абонирай ме отново' : 'Resubscribe me')}
              </button>
            )}
          </div>
        )}

        {status === 'error' && (
          <div data-testid="unsubscribe-error">
            <h1 className="heading-2 mb-3">{lang === 'bg' ? 'Невалиден линк' : 'Invalid link'}</h1>
            <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
              {lang === 'bg'
                ? 'Този линк за отписване е невалиден или е изтекъл.'
                : 'This unsubscribe link is invalid or has expired.'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;
